import { useMutation, useQueryClient } from '@tanstack/react-query';

/**
 * フォーム回答を登録済（status: synced）に更新するフック
 */
export default function useSyncCandidateFormAnswer() {
  const queryClient = useQueryClient();
  const token =
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || '';

  return useMutation({
    mutationFn: async (answerId: number) => {
      const response = await fetch(
        `/agent/api/candidate_forms/candidate_form_answers/${answerId}`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            candidate_form_answer: { status: 'synced' },
          }),
        }
      );

      if (!response.ok) {
        throw new Error('ステータスの更新に失敗しました');
      }
    },
    onSuccess: (_data, answerId) => {
      queryClient.invalidateQueries({ queryKey: ['candidate_form_answers'] });
      queryClient.invalidateQueries({ queryKey: ['candidate_form_answers', answerId] });
    },
  });
}
